export default __webpack_public_path__ + "static/media/BestellungFortsetzen.b25f4651.jpg";